export const UPDATE_PAGE_VALID = "UPDATE_PAGE_VALID";

export const GET_CURRENT_PAGE_DATA = "GET_CURRENT_PAGE_DATE";
export const GET_CURRENT_PAGE = "GET_CURRENT_PAGE";
